export const link = { // eslint-disable-line
  name: 'link',
  bind: (el, binding) => {
    el.addEventListener('click', (event) => {
      event.preventDefault()
      const { Url, Target } = binding.value

      window.open(Url, Target)
    })
  }
}
